<template>
  <div>
    <CCard
      title="Vehicle"
    >
      <CCardHeader>
        <CRow>
          <CCol col=4>
            <CIcon size="2xl" name="cil-grid"/> Vehicle
          </CCol>
          <CCol col=8 class="align-right">
            <CButtonToolbar>
              <input 
                class="search" 
                type="search"
                v-model="findKeyword"
                v-on:input="handleKeyword"
                placeholder="ประเภท, หน่วยงาน, ทะเบียนรถ, ยี่ห้อ, รุ่น, เชื้อเพลิง"
              >
              &nbsp;
              <CButtonGroup>
                <CButton
                  v-on:click="isCreateOrEditVehicle = true; selectedVehicle = {};"
                  name="manage"
                  color="primary"
                  class="d-sm-down-none"
                >
                  Create
                </CButton>
                
              </CButtonGroup>
            </CButtonToolbar>
          </CCol>
        </CRow>

      </CCardHeader>
      <CCardBody>
        <CDataTable
          :hover="false"
          :striped="true"
          :border="true"
          :small="false"
          :fixed="false"
          :items-per-page="20"
          :dark="false"
          pagination
          :items="vehiclesTable"
          :fields="vehiclesTableFields"
        >
          <template #operation="{item}">
            <td>
              <div class="button-wrapper">
                <CButton
                  v-on:click="handleSelectedVehicle(item); getUsage(); isManageUsage = true"
                  name="manage"
                  color="success"
                >
                  Usage 
                </CButton>
                <span v-if="usageCount(item.id) > 0" class="badge">{{ usageCount(item.id) }}</span>
              </div>
              &nbsp;
              
              <CButton
                v-on:click="handleSelectedVehicle(item); isCreateOrEditVehicle = true"
                name="manage"
                color="primary"
              >
                Edit
              </CButton>

              &nbsp;
              <CButton
                v-on:click="handleSelectedVehicle(item); deleteVehicle()"
                name="delete"
                color="danger"
                :disabled="!isDeletabled"
              >
                Delete
              </CButton>

            </td>
          </template>
        </CDataTable>
      </CCardBody>
      <CCardFooter>
        <CRow>
          <CCol sm="6" md="1">
            <CSwitch class="mx-1" color="primary" v-on:update:checked="toggleDelete" :checked="!isDeletabled" variant="opposite" shape="pill" labelOn='yes' labelOff='no' />
          </CCol>
          <CCol sm="6" md="11">
            <p>Prevent Delete Vehicle</p>
          </CCol>
        </CRow>
      </CCardFooter>
    </CCard>
        
    <CModal
      :show.sync="isCreateOrEditVehicle"
      :centered="false"
      color="primary"
      title="Vehicle Information"
      size="lg"
    >
      <CForm>
        <CSelect
          label="ประเภทยานพาหนะ"
          horizontal
          :value.sync="selectedVehicle.type"
          :options="selectVehicleTypeOption"
          placeholder="Please select"
          :is-valid="isValidVehicle('type')"
        />
        <CInput
          v-model="selectedVehicle.department"
          type="text"
          label="หน่วยงานที่ใช้"
          placeholder="Enter Department..."
          horizontal
          required
          id="department"
          autocomplete="on"
          :is-valid="isValidVehicle('department')"
          :invalid-feedback="feedback.department"
        />
        <CSelect
          label="ลักษณะความเป็นเจ้าของ"
          horizontal
          :value.sync="selectedVehicle.ownership"
          :options="selectOwnershipOption"
          placeholder="Please select"
          :is-valid="isValidVehicle('ownership')"
        />
        <CSelect
          label="ปีที่ผลิต"
          horizontal
          :value.sync="selectedVehicle.manufacturing_year"
          :options="selectManufacturingYearOption"
          placeholder="Please select"
          :is-valid="isValidVehicle('manufacturing_year')"
        />
        <CInput
          v-model="selectedVehicle.plate_number"
          type="text"
          label="ทะเบียนรถยนต์"
          placeholder="ทะเบียนรถยนต์ หรือทะเบียนที่ใช้ภายในองค์กร) ..."
          horizontal
          required
          :is-valid="isValidVehicle('plate_number')"
          :invalid-feedback="feedback.plate_number"
        />
        <CInput
          v-model="selectedVehicle.brand"
          type="text"
          label="ยี่ห้อ"
          placeholder="Enter Brand..."
          horizontal
          required
          id="car-brand"
          autocomplete="on"
          :is-valid="isValidVehicle('brand')"
          :invalid-feedback="feedback.brand"
        />
        <CInput
          v-model="selectedVehicle.model"
          type="text"
          label="รุ่น"
          placeholder="Enter model..."
          horizontal
          required
          id="car-model"
          autocomplete="on"
          :is-valid="isValidVehicle('model')"
          :invalid-feedback="feedback.model"
        />
        <CCNumber
          v-model="selectedVehicle.passenger"
          type="text"
          :allowNaN="false"
          label="จำนวนผู้โดยสารเฉลี่ย"
          placeholder="Enter passenger..."
          horizontal
          required
          :is-valid="isValidVehicle('passenger')"
          :invalid-feedback="feedback.passenger"
        />
        <CSelect
          label="ชนิดเชื้อเพลิง"
          horizontal
          :value.sync="selectedVehicle.fuel_type"
          :options="selectFuelTypeOption"
          placeholder="Please select"
          :is-valid="isValidVehicle('fuel_type')"
          @change="reprocessVehicleByFuelType"
        />
        <CInput
          v-model="selectedVehicle.engine_size"
          type="text"
          label="ขนาดเครื่องยนต์ (ลิตร)"
          placeholder="Enter engine size..."
          horizontal
          :disabled="!requiredEngineSize"
          :required="requiredEngineSize"
          :is-valid="isValidEngineSize"
          :invalid-feedback="feedback.engine_size"
        />
        <CInput
          v-model="selectedVehicle.battery_size"
          type="text"
          label="ขนาดแบตเตอรี่ (kWh)"
          placeholder="Enter battery size..."
          horizontal
          :disabled="!requiredBatterySize"
          :required="requiredBatterySize"
          :is-valid="isValidBatterySize"
          :invalid-feedback="feedback.battery_size"
        />
        <CSelect
          label="ชนิดยานพาหนะที่ถูกทดแทน"
          horizontal
          :value.sync="selectedVehicle.replacement"
          :options="selectReplacementOption"
          :is-valid="isValidVehicle('replacement')"
        />
      </CForm>
      <template #footer>
        <CButton v-on:click="isCreateOrEditVehicle = false" color="light">Cancel</CButton>
        <CButton
          v-if="isNewVehicle"
          v-on:click="isCreateOrEditVehicle = false; createVehicle();"
          :disabled="!isValidSelectedVehicle"
          color="success"
        >
          Create
        </CButton>
        <CButton
          v-if="!isNewVehicle"
          v-on:click="isCreateOrEditVehicle = false; updateVehicle();"
          color="success"
          :disabled="!isValidSelectedVehicle"
        >
          Save
        </CButton>
        
        
      </template>
    </CModal>

    <CModal
      :show.sync="isManageUsage"
      :centered="false"
      color="success"
      title="Usage Information"
      size="lg"
    >
      <CCard
        title="Usage"
      >
        <CCardHeader>
          <CRow>
            <CCol col=4>
              <CIcon size="2xl" name="cil-grid"/> Usage
            </CCol>
            <CCol col=8 class="align-right">
              <CButtonToolbar>
                <CButtonGroup>
                  <CButton
                    v-on:click="isCreateOrEditUsage = true; isManageUsage = false; selectedUsage = {}; "
                    name="manage"
                    color="success"
                    class="d-sm-down-none"
                  >
                    Create
                  </CButton>
                </CButtonGroup>
              </CButtonToolbar>
            </CCol>
          </CRow>

        </CCardHeader>
        <CCardBody>
          <CDataTable
            :hover="false"
            :striped="true"
            :border="true"
            :small="false"
            :fixed="false"
            :items-per-page="20"
            :dark="false"
            pagination
            :items="usagesTable"
            :fields="usagesTableFields"
          >
            <template #operation="{item}">
              <td>
                <CButton
                  v-on:click="selectedUsage = item; deleteUsage()"
                  name="delete"
                  size="sm"
                  color="danger"
                  :disabled="!isDeletabled"
                >
                  Delete
                </CButton>
              </td>
            </template>
          </CDataTable>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="6" md="1">
              <CSwitch class="mx-1" color="primary" v-on:update:checked="toggleDelete" :checked="!isDeletabled" variant="opposite" shape="pill" labelOn='yes' labelOff='no' />
            </CCol>
            <CCol sm="6" md="11">
              <p>Prevent Delete Usage</p>
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CModal>

    <div
      v-if="!isManageUsage"
    >
      <CModal
        :show.sync="isCreateOrEditUsage"
        :centered="false"
        color="success"
        title="Usage Information"
        size="lg"
      >
        <CForm >
          <CCmonth
            label="เดือนที่ใช้งาน"
            :startYear="2023"
            :required="true"
            :horizontal="true"
            :value="selectedUsage['month']"
            @input="eventUpdateMonth($event)"
          />
          <!-- <CInput
            v-model="selectedUsage['month']"
            type="text"
            label="Selected Month-Year:"
            placeholder="Enter month..."
            horizontal
            required
            disabled
          /> -->
          <CCNumber
            v-model="selectedUsage.distance"
            type="text"
            :allowNaN="false"
            label="ระยะทาง"
            placeholder="Enter distance..."
            horizontal
            required
            :is-valid="isValidUsage('distance')"
            :invalid-feedback="feedback.distance"
          />
          <CCNumber
            v-model="selectedUsage.fuel"
            type="text"
            :allowNaN="false"
            label="ปริมาณเชื้อเพลิงที่ใช้ (ลิตรหรือกิโลกรัม)"
            placeholder="Enter fuel (Liter or Kilogram)..."
            horizontal
            :disabled="!requiredEngineSize"
          />
          <CCNumber
            v-model="selectedUsage.electric"
            type="text"
            :allowNaN="false"
            label="ปริมาณไฟฟ้าที่ใช้ (kWh)"
            placeholder="Enter electric (kWh)..."
            horizontal
            :disabled="!requiredBatterySize"
          />
        </CForm>
        <template #footer>
          <CButton v-on:click="isManageUsage = true; isCreateOrEditUsage = false" color="light">Cancel</CButton>
          <CButton
            v-on:click="isManageUsage = true; isCreateOrEditUsage = false; createUsage();"
            color="success"
            :disabled="!isValidSelectedUsage"
          >
            Create
          </CButton>
          
        </template>
      </CModal>
    </div>
    <Snackbar :isActivated="isAlert" :message="alertMessage" :color="alertColor"></Snackbar>

  </div>
</template>

<script>
import config  from '@/config'
import { axiosInstance } from '@/api'
// import { range, parseQueryString, parseBoolString, stringToHex } from '@/utils'

import Snackbar from '@/vue/base/Snackbar.vue'
import CCmonth from '@/vue/base/CCmonth.vue'
import CCNumber from '@/vue/base/CCNumber.vue'

import '@/assets/scss/search_box.scss'

// for month pickr
// import flatpickr from "flatpickr";
// import "flatpickr/dist/flatpickr.min.css";
// import monthSelectPlugin from "flatpickr/dist/plugins/monthSelect";
// import "flatpickr/dist/plugins/monthSelect/style.css";

import Ajv from "ajv"
import { TRUE } from 'sass'

// import { CInput } from '@coreui/vue'

const ajv = new Ajv()

export default {
  name: 'Vehicle',
  components: { Snackbar, CCmonth, CCNumber },
  data () {
    return {
      numberValue: 0,
      isDeletabled: false,
      isManageInfo: false,
      isManageVehicle: false,
      isCreateOrEditVehicle: false,
      isManageUsage: false,
      isCreateOrEditUsage: false,
      isAlert: false,
      alertCountDown: 0,
      alertColor: 'info',
      alertMessage: '',
      findKeyword: '',
      feedback: {},
      user: {},
      VehicleSchema: {},
      vehicle: {},
      vehicles: [],
      selectedVehicle: {},
      vehiclesTableFields:  [
        { key: 'type', label: 'ประเภท' },
        { key: 'department', label: 'หน่วยงาน' },
        { key: 'plate_number', label: 'ทะเบียนรถยนต์' },
        { key: 'brand', label: 'ยี่ห้อ' },
        { key: 'model', label: 'รุ่น' },
        { key: 'fuel_type', label: 'ชนิดเชื้อเพลิง' },
        { key: 'engine_size', label: 'ขนาดเครื่องยนต์' },
        { key: 'battery_size', label: 'ขนาดแบตเตอรี่' },
        { key: 'operation', label: 'Operation' }
      ],
      UsageSchema: {},
      usage: {},
      usages: [],
      selectedUsage: {},
      usagesTableFields:  [
        { key: 'month', label: 'เดือน' },
        { key: 'distance', label: 'ระยะทาง' },
        { key: 'fuel', label: 'ปริมาณเชื้อเพลิง' },
        { key: 'electric', label: 'ปริมาณไฟฟ้า' },
        { key: 'operation', label: 'Operation' }
      ],
      // selectFuelTypeOption: [
      //   { 
      //     value: 'fuel', 
      //     label: 'น้ำมัน'
      //   },
      //   { 
      //     value: 'gas', 
      //     label: 'แก็ส NGV/LPG'
      //   },
      //   {
      //     value: 'electric',
      //     label: 'ไฟฟ้า'
      //   },
      //   {
      //     value: 'hybrid',
      //     label: 'hybrid'
      //   },
      // ],
      selectFuelTypeOption: [
        {
          value: 'electric',
          label: 'ไฟฟ้า'
        },
        {
          value: 'hybrid',
          label: 'ไฮบริด'
        },
        { 
          value: 'bensin', 
          label: 'เบนซิน'
        },
        { 
          value: 'e85', 
          label: 'E85'
        },
        { 
          value: 'e20', 
          label: 'E20'
        },
        { 
          value: 'diesel', 
          label: 'ดีเซล'
        },
        { 
          value: 'lpg', 
          label: 'LPG'
        },
        { 
          value: 'ngv', 
          label: 'NGV'
        },
      ],
      selectVehicleTypeOption: [
        { 
          value: 'vehicle_01', 
          label: 'รถยนต์ที่นั่งส่วนบุคคลไม่เกิน 7 คน'
        },
        { 
          value: 'vehicle_02', 
          label: 'รถยนต์ที่นั่งส่วนบุคคลเกิน 7 คน'
        },
        { 
          value: 'vehicle_03', 
          label: 'รถยนต์บรรทุกส่วนบุคคล'
        },
        { 
          value: 'vehicle_04', 
          label: 'รถยนต์สามล้อส่วนบุคคล'
        },
        { 
          value: 'vehicle_05', 
          label: 'รถยนต์รับจ้างระหว่างจังหวัด'
        },
        { 
          value: 'vehicle_06', 
          label: 'รถยนต์ที่รับจ้างบรรทุกคนโดยสารไม่เกิน 7 คน'
        },
        { 
          value: 'vehicle_07', 
          label: 'รถยนต์สี่ล้อเล็กรับจ้าง'
        },
        { 
          value: 'vehicle_08', 
          label: 'รถยนต์รับจ้างสามล้อ'
        },
        { 
          value: 'vehicle_09', 
          label: 'รถยนต์บริการธุรกิจ'
        },
        { 
          value: 'vehicle_10', 
          label: 'รถยนต์บริการทัศนาจร'
        },
        { 
          value: 'vehicle_11', 
          label: 'รถยนต์บริการให้เช่า'
        },
        { 
          value: 'vehicle_12', 
          label: 'รถจักรยานยนต์ส่วนบุคคล'
        },
        { 
          value: 'vehicle_13', 
          label: 'รถแทรกเตอร์'
        },
        { 
          value: 'vehicle_14', 
          label: 'รถบดถนน'
        },
        { 
          value: 'vehicle_15', 
          label: 'รถใช้งานเกษตรกรรม'
        },
        { 
          value: 'vehicle_16', 
          label: 'รถพ่วง'
        },
        { 
          value: 'vehicle_17', 
          label: 'รถจักรยานยนต์สาธารณะ'
        },
      ],
      selectOwnershipOption: [
        { 
          value: 'own', 
          label: 'รถซื้อ'
        },
        { 
          value: 'rent', 
          label: 'รถเช่า'
        },
      ],
      selectReplacementOption: [
        { 
          value: '', 
          label: 'ไม่มี (พาหนะใหม่)'
        },
        { 
          value: 'ice', 
          label: 'รถน้ำมัน'
        },
        { 
          value: 'ev', 
          label: 'รถไฟฟ้า'
        },
        { 
          value: 'hybrid', 
          label: 'รถไฮบริด'
        },
      ],
      usageCounts: {},
      selectManufacturingYearOption: [
      ],
      selectedMonthYear: "", // Model to hold the selected date
    }
  },
  computed: {
    isValidBatterySize () {
      if (this.requiredBatterySize) {
        if (this.selectedVehicle.battery_size) {
          return this.isValidVehicle('battery_size')
        } else {
          return false
        }
      } else {
        return true
      }
    },
    isValidEngineSize () {
      if (this.requiredEngineSize) {
        if (this.selectedVehicle.engine_size) {
          return this.isValidVehicle('engine_size')
        } else {
          return false
        }
      } else {
        // console.log('isValidEngineSize = true')
        return true
      }
    },
    requiredEngineSize () {
      switch (this.selectedVehicle.fuel_type) {
        case 'diesel':
        case 'bensin':
        case 'e20':
        case 'e85':
        case 'lpg':
        case 'ngv':
        case 'hybrid':
          return true
        default:
          return false
      }
    },
    requiredBatterySize () {
      switch (this.selectedVehicle.fuel_type) {
        case 'electric':
        case 'hybrid':
          return true
        default:
          return false
      }
    },
    usagesTable () {
      let usages = []
      for(let i = 0; i < this.usages.length; i++) {
        let usage = Object.assign({},this.usages[i])
        let keys = ['fuel', 'electric']
        for(let j = 0; j < keys.length; j++) {
          if (usage[keys[j]] === undefined || usage[keys[j]] === null) {
            usage[keys[j]] = '-'
          }
        }
        usages.push(usage)
      }
      return usages
    },
    vehiclesTable () {
      let vehicles = []
      for(let i = 0; i < this.vehicles.length; i++) {
        let vehicle = Object.assign({},this.vehicles[i])

        vehicle['type'] = this.findLabelByValue(this.selectVehicleTypeOption , vehicle['type'])
        vehicle['fuel_type'] = this.findLabelByValue(this.selectFuelTypeOption, vehicle['fuel_type'])
        vehicle['engine_size'] = vehicle['engine_size'] ?? ''
        vehicle['battery_size'] = vehicle['battery_size'] ?? ''

        vehicles.push(vehicle)
      }
      
      let filteredVehicles = []
      for(let i = 0; i < vehicles.length; i++) {
        if (
          vehicles[i]['type'].includes(this.findKeyword)
          || vehicles[i]['department'].includes(this.findKeyword)
          || vehicles[i]['plate_number'].includes(this.findKeyword)
          || vehicles[i]['brand'].includes(this.findKeyword)
          || vehicles[i]['model'].includes(this.findKeyword)
          || vehicles[i]['fuel_type'].includes(this.findKeyword)
        ) {
          filteredVehicles.push(vehicles[i])
        }
      }
      return filteredVehicles
    },
    isValidSelectedVehicle () {
      const isValid = ajv.validate(this.VehicleSchema, this.selectedVehicle)
      if (!isValid) { 
        return false
      } else {
        return true
      }
    },
    isValidSelectedUsage () {
      const isValid = ajv.validate(this.UsageSchema, this.selectedUsage)
      if (!isValid) { 
        return false
      } else {
        return true
      }
    },
    isNewVehicle () {
      if(Object.hasOwn(this.selectedVehicle, 'id')) {
        if (typeof this.selectedVehicle.id === 'number') {
          return false
        }
      }
      return true
    },
  },
  mounted() {
    this.getVehicleSchema()
    this.getVehicle()
    this.getUsageSchema()
    this.initManufacturingYearOption()
    this.getUsageCount()
    // this.getVehicleOrganization()
  },
  watch: {
  },
  methods: {
    initManufacturingYearOption() {
      this.selectManufacturingYearOption.push({
        value: "",
        label: "--Select-Year--",
      });
      const endYear = new Date().getFullYear()
      const startYear = 1990
      for (let year = endYear; year >= startYear; year--) {
        this.selectManufacturingYearOption.push({
          value: String(year),
          label: year,
        });
      }
    },
    reprocessVehicleByFuelType(event) {
      // console.log('on change fuel type: '+event)
      // console.log(event)
      this.selectedVehicle.fuel_type = event.target.value
      switch (event.target.value) {
        case 'electric':
          delete this.selectedVehicle.engine_size
          break;
        case 'diesel':
        case 'bensin':
        case 'e20':
        case 'e85':
        case 'lpg':
        case 'ngv':
          delete this.selectedVehicle.battery_size
          break;
        default:
          break;
      }
    },
    eventUpdateMonth(value) {
      // console.log('event: update month: '+ value)
      this.$set(this.selectedUsage, "month", value); // Updates the property reactively
    },
    usageCount(vehicleId) {
      let usageCount = 0
      if (typeof this.usageCounts[vehicleId] === 'number' && !isNaN(this.usageCounts[vehicleId])) {
        usageCount = this.usageCounts[vehicleId]
      }
      let notificationCount = 3 - usageCount
      if(notificationCount > 0){
        return notificationCount
      } else {
        return 0
      }
    },
    findLabelByValue(options, searchValue) {
      const foundOption = options.find(option => option.value === searchValue)
      return foundOption ? foundOption.label : ''
    },
    toggleDelete () {
      this.isDeletabled = !this.isDeletabled
    },
    isValidUsage (key) {
      if (this.UsageSchema) {
        if (Object.hasOwn(this.selectedUsage, key)) {
          // console.log('key: ' + key + ' is exist')
          const isValid = ajv.validate(this.UsageSchema.properties[key], this.selectedUsage[key])
          if (isValid) {
            return true
          } else {
            if (!this.UsageSchema['required'].includes(key) && this.selectedUsage[key] === '') {
              // console.log('key: ' + key + ' is exist, not require, and empty then delete !!!')
              delete this.selectedUsage[key]
              return true
            } else {
              this.feedback[key] = ajv.errors[0].message
              return false
            }
          }
        } else {
          if (this.UsageSchema['required'] && !this.UsageSchema['required'].includes(key)) {
            return true
          } else {
            return false
          }
        }
      } else {
        return false
      }
    },
    isValidVehicle (key) {
      if (this.VehicleSchema) {
        if (Object.hasOwn(this.selectedVehicle, key)) {
          // console.log('key: ' + key + ' is exist')
          const isValid = ajv.validate(this.VehicleSchema.properties[key], this.selectedVehicle[key])
          if (isValid) {
            return true
          } else {
            if (!this.VehicleSchema['required'].includes(key) && this.selectedVehicle[key] === '') {
              // console.log('key: ' + key + ' is exist, not require, and empty then delete !!!')
              delete this.selectedVehicle[key]
              return true
            } else {
              // console.log('key: ' + key + ' is exist and not empty')
              this.feedback[key] = ajv.errors[0].message
              return false
            }
          }
        } else {
          // console.log('key: ' + key + ' is not exist')
          if (this.VehicleSchema['required'] && !this.VehicleSchema['required'].includes(key)) {
            // console.log('key: ' + key + ' is not require')
            return true
          } else {
            // console.log('key: ' + key + ' is require !!!')
            return false
          }
        }
      } else {
        return false
      }
    },
    handleKeyword () {
      // Nothing to do, the keyword is used in computed()
    },
    handleSelectedVehicle (vehicle) {
      let data = {}
      for(let i = 0; i < this.vehicles.length; i++) {
        if (this.vehicles[i].id == vehicle.id) {
          data = Object.assign({},this.vehicles[i])
        }
      }

      if(!vehicle.engine_size) {
        delete data.engine_size
      }
      if(!vehicle.battery_size) {
        delete data.battery_size
      }
      
      delete data.createdAt
      delete data.updatedAt
      this.selectedVehicle = data

      // this.isCreateOrEditVehicle = true
    },
    getUsageSchema () {
      axiosInstance({
        method: 'get',
        url: '/usage/schema'
      })
      .then(response => {
        if(response.status === 200) {
          let schemas = {}
          Object.assign(schemas, response.data)
          let properties = {}
          Object.assign(properties, schemas.properties)
          delete schemas.properties
          schemas.properties = {}
          for (const [key, value] of Object.entries(properties)) {
            delete value.hint
            schemas.properties[key] = value
          }
          this.UsageSchema = schemas
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    getUsageCount () {
      axiosInstance({
        method: 'get',
        url: '/usage/count',
      })
      .then(response => {
        // console.log(`get Usage Count: ${JSON.stringify(response.data, null, 2)}`)
        if(response.status === 200) {
          let usageCounts = {}
          response.data.forEach((usage) => {
            // console.log(`Vehicle ID: ${usage.vehicleId}, Usage Count: ${usage.usageCount}`);
            usageCounts[usage.vehicleId] = usage.usageCount
          })
          this.usageCounts = usageCounts
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    getUsage () {
      axiosInstance({
        method: 'post',
        url: '/usage/search',
        data: {
          vehicleId: this.selectedVehicle.id
        }
      })
      .then(response => {
        // console.log(`get Usage: ${JSON.stringify(response.data, null, 2)}`)
        if(response.status === 200) {
          this.usages = response.data
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    createUsage () {
      let data = Object.assign({},this.selectedUsage)
      data.vehicleId = this.selectedVehicle.id
      let keys = ['distance', 'fuel', 'electric']
      for(let i = 0; i < keys.length; i++) {
        if (data[keys[i]] == 0) {
          console.log('remove '+keys[i])
          delete data[keys[i]]
        }
      }

      // console.log(`payload: ${JSON.stringify(data, null, 2)}`)
      axiosInstance({
        method: 'post',
        url: '/usage/',
        data
      })
      .then(response => {
        if(response.status === 200) {
          this.usage = Object.assign({},response.data)
          this.alertColor = 'success'
          this.alertMessage = 'create usage success'
          this.isAlert = !this.isAlert

          // this.getVehicle()
          this.usages.push(response.data)
          this.getUsageCount()
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          // console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
          this.alertColor = 'danger'
          this.alertMessage = `Error [${error.response.status}]: ${JSON.stringify(error.response.data)}`
          this.isAlert = !this.isAlert
        }
      })
    },
    deleteUsage () {
      axiosInstance({
        method: 'delete',
        url: '/usage/',
        data: this.selectedUsage
      })
      .then(response => {
        if(response.status === 200) {
          // console.log(`response.data: ${JSON.stringify(response.data, null, 2)}`)
          this.alertColor = 'success'
          this.alertMessage = 'update usage success'
          this.isAlert = !this.isAlert

          this.getUsageCount()
          for(let i = 0; i < this.usages.length; i++) {
            if (this.usages[i].id == this.selectedUsage.id) {
              this.usages.splice(i,1)
              break
            }
          }
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          // console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
          this.alertColor = 'danger'
          this.alertMessage = `Error [${error.response.status}]: ${JSON.stringify(error.response.data)}`
          this.isAlert = !this.isAlert
        }
      })
    },
    getVehicleSchema () {
      axiosInstance({
        method: 'get',
        url: '/vehicle/schema'
      })
      .then(response => {
        if(response.status === 200) {
          let schemas = {}
          Object.assign(schemas, response.data)
          let properties = {}
          Object.assign(properties, schemas.properties)
          delete schemas.properties
          schemas.properties = {}
          for (const [key, value] of Object.entries(properties)) {
            delete value.hint
            schemas.properties[key] = value
          }
          this.VehicleSchema = schemas
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    getVehicle () {
      axiosInstance({
        method: 'get',
        url: '/vehicle/'
      })
      .then(response => {
        // console.log(`get Vehicle: ${JSON.stringify(response.data, null, 2)}`)
        if(response.status === 200) {
          this.vehicles = response.data
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
        }
      })
    },
    updateVehicle () {
      axiosInstance({
        method: 'put',
        url: '/vehicle/',
        data: this.selectedVehicle
      })
      .then(response => {
        if(response.status === 200) {
          this.vehicle = Object.assign({},response.data)
          this.alertColor = 'success'
          this.alertMessage = 'update vehicle success'
          this.isAlert = !this.isAlert
          // this.getVehicle()
          // ### replace vehicle by id
          for(let i = 0; i < this.vehicles.length; i++) {
            if (this.vehicles[i].id == response.data.id) {
              this.vehicles.splice(i,1)
              this.vehicles.push(response.data)
              break
            }
          }
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          // console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
          this.alertColor = 'danger'
          this.alertMessage = `Error [${error.response.status}]: ${JSON.stringify(error.response.data)}`
          this.isAlert = !this.isAlert
        }
      })
    },
    createVehicle () {
      axiosInstance({
        method: 'post',
        url: '/vehicle/',
        data: this.selectedVehicle
      })
      .then(response => {
        if(response.status === 200) {
          // console.log(`create Vehicle: ${JSON.stringify(response.data, null, 2)}`)
          this.vehicle = Object.assign({},response.data)
          this.alertColor = 'success'
          this.alertMessage = 'create vehicle success'
          this.isAlert = !this.isAlert

          // this.getVehicle()
          this.vehicles.push(response.data)
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          // console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
          this.alertColor = 'danger'
          this.alertMessage = `Error [${error.response.status}]: ${JSON.stringify(error.response.data)}`
          this.isAlert = !this.isAlert
        }
      })
    },
    deleteVehicle () {
      axiosInstance({
        method: 'delete',
        url: '/vehicle/',
        data: this.selectedVehicle
      })
      .then(response => {
        if(response.status === 200) {
          // console.log(`response.data: ${JSON.stringify(response.data, null, 2)}`)
          // this.vehicle = response.data
          this.alertColor = 'success'
          this.alertMessage = 'update vehicle success'
          this.isAlert = !this.isAlert

          // this.getVehicle()
          for(let i = 0; i < this.vehicles.length; i++) {
            if (this.vehicles[i].id == this.selectedVehicle.id) {
              this.vehicles.splice(i,1)
              break
            }
          }
        }
      })
      .catch(error => {
        console.log(error)
        if (error.response) {
          // console.log(`Error [${error.response.status}]: ${JSON.stringify(error.response.data, null, 2)}`)
          this.alertColor = 'danger'
          this.alertMessage = `Error [${error.response.status}]: ${JSON.stringify(error.response.data)}`
          this.isAlert = !this.isAlert
        }
      })
    },

  }
}
</script>

<style scoped lang="scss">
  // .table-header {
  //   font-size: 1rem;
  //   margin-bottom: -15px;
  // }

  /* Center align content in the first column */
  .align-center {
    // text-align: center;
    display: flex;
    align-items: center; /* Vertical alignment */
    justify-content: center; /* Horizontal alignment */
  }

  /* Right align content in the second column */
  .align-right {
    display: flex;
    align-items: right; /* Vertical alignment */
    justify-content: right; /* Horizontal alignment */
  }

  .button-wrapper {
    position: relative;
    display: inline-block;
  }

  .badge {
    position: absolute;
    
    background-color: red;
    color: white;
    border-radius: 50%;
    font-size: 20px;
    width: 30px;
    height: 30px;
    top: -10px;
    right: -12px;
    // ### original size
    // font-size: 12px;
    // width: 20px;
    // height: 20px;
    // top: -5px;
    // right: -10px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
  }
</style>